import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FinancialDataService {
  private apiUrl =
    'https://typesense.infomanav.in/collections/lembda_company_financials_series/documents/search?q=*&per_page=5&filter_by=company_symbol%3A000004.SZ';

  private headers = {
    'x-typesense-api-key': 'WwQySUDzbI3tNEozoarFJM9dsKFbeaXjNFKROidedC4ZFjD5', // Replace with your actual API key
  };

  constructor(private http: HttpClient) {}

  fetchFinancialData(): Promise<any> {
    return lastValueFrom(this.http.get(this.apiUrl, { headers: this.headers }).pipe(
      catchError(error => {
        console.error('Error fetching financial data:', error);
        return throwError(() => error);
      })
    ));
  }
}
